import React from 'react'
import "./styles/CreateProjectButton.scss";
import buttonIcon from "./img/edit-icon.svg";
import { FormattedMessage } from 'react-intl';
import proquinalHistory from 'services/browser-history';
import { graphql, compose } from 'react-apollo';
import meQuery from 'utils/queries/MeQuery';

const CreateProjectButton = ({ meQuery }) => {
  const { me } = meQuery;

  const goToCreateProject = () => 
    proquinalHistory.push({ 
      pathname: '/project/creation-form'
    });

  return (
    me?.hasCreateProjectAccess ? (
      <button className="create_project-btn" onClick={goToCreateProject}>
        <img
          src={buttonIcon}
          alt="create-project-icon"
          className="create_project-btn__icon"
        />
        <FormattedMessage
          id="CreateProjectButton.createProject"
          defaultMessage="Create Project"
        />
      </button>
    ) : null
  );
}

export default compose(
  graphql(meQuery, {
    name: "meQuery"
  })
)(CreateProjectButton);
